import styled from "styled-components";

export const StyledToastContainer = styled.div<{ size?: "small" | "regular" | "large" }>`
    width: ${(props) => (props.size === "small" ? props.theme.rem(16) : props.size === "regular" ? props.theme.rem(28) : props.theme.rem(32.5))};
    position: relative;
`;
